import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { CommonValidators } from '..';

@Injectable({
  providedIn: 'root',
})
export class PasswordRequirementsService {
  readonly params = {
    requiredLength: 8,
  };

  readonly errorMap: { [key: string]: string } = {
    required: _('Uss.Password.Validation.Password.Required'),
    minlength: _('Uss.Common.Validation.MinLength'),
    containsLowercaseCharacter: _('Uss.Password.Validation.Password.Lowercase'),
    containsUppercaseCharacter: _('Uss.Password.Validation.Password.Uppercase'),
    containsNumber: _('Uss.Password.Validation.Password.Number'),
  };

  readonly validators = [
    Validators.required,
    Validators.minLength(this.params.requiredLength),
    CommonValidators.containsLowercaseCharacter,
    CommonValidators.containsUppercaseCharacter,
    CommonValidators.containsNumber,
  ];
}
